/**
 * Debug banner removed - native detection confirmed working.
 * The issue was: user wasn't running `git pull` before `npm run build`.
 */
export function RuntimeDebugBanner() {
  return null;
}
